import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@/context/ThemeContext';
import { AuthProvider } from '@/context/AuthContext';
import ProtectedRoute from '@/components/common/ProtectedRoute';
import LoadingSpinner from '@/components/common/LoadingSpinner';

// Lazy loading components
const LandingPage = lazy(() => import('@/pages/LandingPage').catch(() => ({ default: () => <div>Landing Page Placeholder</div> })));
const LoginPage = lazy(() => import('@/pages/LoginPage').catch(() => ({ default: () => <div>Login Page Placeholder</div> })));
const SignupPage = lazy(() => import('@/pages/SignupPage').catch(() => ({ default: () => <div>Signup Page Placeholder</div> })));
const ForgotPasswordPage = lazy(() => import('@/pages/ForgotPasswordPage').catch(() => ({ default: () => <div>Forgot Password Placeholder</div> })));
const DashboardPage = lazy(() => import('@/pages/DashboardPage').catch(() => ({ default: () => <div>Dashboard Placeholder</div> })));

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            {/* Direct Trading Platform Routes - All open instantly */}
            <Route path="/" element={<DashboardPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/dashboard/*" element={<DashboardPage />} />
            <Route path="/market-wise" element={<DashboardPage />} />
            <Route path="/trade-flow" element={<DashboardPage />} />
            <Route path="/market-gainers" element={<DashboardPage />} />
            <Route path="/stock-on" element={<DashboardPage />} />
            <Route path="/swing-spectrum" element={<DashboardPage />} />
            <Route path="/trade-ai" element={<DashboardPage />} />
            <Route path="/tradex" element={<DashboardPage />} />
            <Route path="/trade-brahmand" element={<DashboardPage />} />
            <Route path="/option-clock" element={<DashboardPage />} />
            <Route path="/index-mover" element={<DashboardPage />} />
            <Route path="/learn" element={<DashboardPage />} />
            <Route path="/my-profile" element={<DashboardPage />} />
            <Route path="/profile" element={<DashboardPage />} />

            {/* Public Auth & Landing routes */}
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />

            {/* Dynamic Tab or fallback */}
            <Route path="/:tabId" element={<DashboardPage />} />
            <Route path="*" element={<DashboardPage />} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
